import {VehicleCatalogueEnumOption} from './VehicleCatalogueEnumOption';
import {VehicleType} from './VehicleType';

export type VehicleCatalogueProperties<
  P = {
    name: string;
    value: unknown;
  },
> = Array<{
  options: VehicleCatalogueEnumOption<P>[];
  vehicleTypes: VehicleType[];
}>;
